var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mt-4",attrs:{"mobile-breakpoint":"0","items-per-page":5,"item-key":"studentCode","headers":_vm.originHeaders,"items":_vm.priceStudent,"footer-props":{
    'items-per-page-text': 'Hiển thị mỗi trang',
    'items-per-page-all-text': 'Tất cả'
  },"disable-sort":""},scopedSlots:_vm._u([{key:"item.index",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.index)+"\n  ")]}},{key:"item.teacher",fn:function(ref){
  var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.name))]),(item.phone === 'Thiếu thông tin')?_c('div',{staticClass:"text-error"},[_vm._v(_vm._s(item.phone))]):_c('div',[_vm._v(_vm._s(item.phone))])]}},{key:"item.dob",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.dob)+"\n  ")]}},{key:"item.gender",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.gender)+"\n  ")]}},{key:"item.class",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.class)+"\n  ")]}},{key:"item.price",fn:function(ref){
  var item = ref.item;
return [(item.price === 'Lỗi dữ liệu')?_c('div',{staticClass:"text-error"},[_vm._v("\n      "+_vm._s(item.price)+"\n    ")]):_c('div',[_vm._v("\n      "+_vm._s(item.price && item.price.toLocaleString('en-US'))+_vm._s(item.type.includes('%') ? '%' : ' VND')+"\n    ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }